import { EntityInProgressChip as EntityInProgressChipType } from '@/schemas/sceneDataSchema';
import { useEntityValidity } from '@/hooks/use-entity-validity';
import { ChipColors, ChipSizes, ChipVariant } from '@/constants/chipTypes';
import { InertChip } from './InertChip';

export function EntityInProgressChip({ component }: { component: EntityInProgressChipType }) {
  const isValid = useEntityValidity(component.scope, component.entity_index);

  if (isValid) return null;

  return (
    <InertChip
      label='In progress'
      size={ChipSizes.SMALL}
      color={ChipColors.WARNING}
      variant={ChipVariant.FILLED}
    />
  );
}
